import React from 'react';
import { CheckCircle2, OctagonX } from 'lucide-react';
import { MorganAvatar } from './MorganAvatar';
import { Badge } from '../ui/badge';

const fmt = (s) => Object.entries(s).filter(([k]) => !['action', 'status', 'action_id', 'review_queue_ids', 'row_ids', 'fired'].includes(k))
  .map(([k, v]) => `${k.replace(/_/g, ' ')}: ${typeof v === 'object' ? JSON.stringify(v) : v}`).join(' · ');

export const MorganAutorunCard = ({ action }) => {
  const r = action.output || {};
  const halted = r.status === 'halted_by_kill_switch';
  const ms = r.match_summary || {};
  return (
    <div className="rounded-lg border border-sky-200 bg-sky-50 p-3 text-xs space-y-2" data-testid={`morgan-autorun-${action.id}`}>
      <div className="flex items-center gap-2">
        <MorganAvatar size={20} />
        <span className="font-semibold">Autonomous run · Level {r.level}</span>
        <Badge variant="outline" className={`ml-auto text-[10px] ${halted ? 'border-rose-300 text-rose-700' : ''}`} data-testid={`morgan-autorun-status-${action.id}`}>
          {halted ? 'halted by kill switch' : r.status}
        </Badge>
      </div>
      {ms.counts && (
        <div data-testid={`morgan-autorun-summary-${action.id}`}>
          {ms.row_count}/{ms.total_rows} rows{ms.capped ? ' (row cap reached)' : ''} · match rate {Math.round((ms.match_rate || 0) * 100)}% · health {ms.health_score}
          {' · '}deterministic {ms.bands?.deterministic} · fingerprint {ms.bands?.fingerprint} · AI {ms.bands?.ai_assisted}
        </div>
      )}
      <ul className="space-y-1">
        {(r.steps || []).map((s, i) => (
          <li key={`${s.action}-${i}`} className="flex gap-2" data-testid={`morgan-autorun-step-${s.action}`}>
            {s.status === 'halted' ? <OctagonX className="w-3.5 h-3.5 text-rose-600 shrink-0" /> : <CheckCircle2 className="w-3.5 h-3.5 text-emerald-600 shrink-0" />}
            <span><span className="font-medium">{s.action.replace(/_/g, ' ')}</span> - {fmt(s)}{s.fired?.length ? ` · fired: ${s.fired.map((f) => f.trigger).join(', ')}` : ''}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
